<template>
  <div class="platform-config-page">
    <div class="page-header">
      <h2 class="page-title">平台配置</h2>
    </div>

    <div class="table-container">
      <table class="config-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>平台编码</th>
            <th>配置项名称</th>
            <th>配置键</th>
            <th>配置值</th>
            <th>备注</th>
            <th>更新时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in configs" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.platform_code }}</td>
            <td>{{ configName(item.config_key) }}</td>
            <td>{{ item.config_key }}</td>
            <td>{{ configValueText(item) }}</td>
            <td class="remark-cell">{{ item.remark || '-' }}</td>
            <td>{{ item.updated_at || '-' }}</td>
            <td>
              <button @click="openEditModal(item)" class="action-btn edit">编辑</button>
            </td>
          </tr>
          <tr v-if="configs.length === 0">
            <td colspan="7" class="empty-cell">暂无配置</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 编辑弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>编辑配置</h3>
          <button @click="closeModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>配置键</label>
            <input :value="editingItem.config_key" type="text" class="form-control" disabled />
          </div>
          <div class="form-group">
            <label>{{ configName(editingItem.config_key) }} <span class="required">*</span></label>
            <input v-model="form.config_value" type="text" class="form-control" :placeholder="configPlaceholder(editingItem.config_key)" />
            <p class="form-tip" v-if="configTip(editingItem.config_key)">{{ configTip(editingItem.config_key) }}</p>
          </div>
          <div class="form-group">
            <label>备注</label>
            <input v-model="form.remark" type="text" class="form-control" placeholder="可选" />
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="btn-cancel">取消</button>
          <button @click="save" class="btn-save">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPlatformConfigs, updatePlatformConfig } from '@/api/platformConfig'

export default {
  name: 'PlatformConfig',
  data() {
    return {
      configs: [],
      showModal: false,
      editingItem: null,
      form: {
        config_value: '',
        remark: ''
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    async loadList() {
      try {
        const res = await getPlatformConfigs()
        if (res && res.code === 0 && res.data) {
          this.configs = res.data.list || []
        }
      } catch (error) {
      }
    },
    openEditModal(item) {
      this.editingItem = item
      this.form = {
        config_value: item.config_value,
        remark: item.remark || ''
      }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.editingItem = null
      this.form = { config_value: '', remark: '' }
    },
    configName(key) {
      const map = {
        withdraw_fee_rate: '提现手续费率',
        withdraw_fee_min_amount: '提现手续费下限（分）',
        withdraw_single_min_amount: '单笔最低提现（分）',
        withdraw_single_max_amount: '单笔最高提现（分）',
        withdraw_daily_limit: '每日提现次数上限（0=不限）',
        withdraw_rule_service_time: '提现规则说明-提现时间',
        withdraw_rule_audit_time: '提现规则说明-审核时间',
        withdraw_rule_arrival_time: '提现规则说明-到账时间'
      }
      return map[key] || key
    },
    configValueText(item) {
      const key = item.config_key
      const val = item.config_value
      if (key === 'withdraw_fee_rate') {
        return val + ' %'
      }
      if (['withdraw_fee_min_amount', 'withdraw_single_min_amount', 'withdraw_single_max_amount'].includes(key)) {
        return val + ' 分（' + (Number(val) / 100).toFixed(2) + ' 元）'
      }
      if (key === 'withdraw_daily_limit') {
        return val + ' 次'
      }
      return val
    },
    configPlaceholder(key) {
      if (key === 'withdraw_fee_rate') return '百分比整数，如 1 表示 1%'
      if (['withdraw_fee_min_amount', 'withdraw_single_min_amount', 'withdraw_single_max_amount'].includes(key)) {
        return '单位：分，如 100 表示 1 元'
      }
      if (key === 'withdraw_daily_limit') return '单位：次，0 表示不限制'
      if (key === 'withdraw_rule_service_time') return '如：每日 00:00-23:59 可提交提现申请'
      if (key === 'withdraw_rule_audit_time') return '如：工作日 09:00-18:00 审核'
      if (key === 'withdraw_rule_arrival_time') return '如：审核通过后 1-3 个工作日到账（法定节假日顺延）'
      return '请输入配置值'
    },
    configTip(key) {
      if (key === 'withdraw_fee_rate') return '按百分比整数填写，例如 1 表示收取提现金额的 1% 作为手续费。'
      if (['withdraw_fee_min_amount', 'withdraw_single_min_amount', 'withdraw_single_max_amount'].includes(key)) {
        return '单位：分（1 元 = 100 分）。单笔最低不可高于单笔最高。'
      }
      if (key === 'withdraw_daily_limit') return '单位：次/日。0 表示每日不限制提现次数。'
      if (key === 'withdraw_rule_service_time') return '将在小程序提现页面「提现规则」中展示为提现时间说明。'
      if (key === 'withdraw_rule_audit_time') return '将在小程序提现页面「提现规则」中展示为审核时间说明。'
      if (key === 'withdraw_rule_arrival_time') return '将在小程序提现页面「提现规则」中展示为到账时间说明。'
      return ''
    },
    async save() {
      if (this.form.config_value === '' || this.form.config_value === null || this.form.config_value === undefined) {
        alert('请输入配置值')
        return
      }

      const key = this.editingItem.config_key
      const v = Number(this.form.config_value)
      const ranges = {
        withdraw_fee_rate: [0, 100],
        withdraw_fee_min_amount: [0, 100000],
        withdraw_single_min_amount: [1, 100000000],
        withdraw_single_max_amount: [1, 100000000],
        withdraw_daily_limit: [0, 1000]
      }
      if (Object.prototype.hasOwnProperty.call(ranges, key)) {
        const [min, max] = ranges[key]
        if (!Number.isInteger(v) || v < min || v > max) {
          alert('「' + this.configName(key) + '」需为 ' + min + '-' + max + ' 之间的整数')
          return
        }
      }

      try {
        await updatePlatformConfig(key, {
          config_value: String(this.form.config_value),
          remark: this.form.remark
        })
        alert('保存成功')
        this.closeModal()
        this.loadList()
      } catch (error) {
        const msg = error && error.response && error.response.data && error.response.data.message
        alert(msg || '保存失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.platform-config-page {
  padding: 20px;
}

.page-header {
  margin-bottom: 16px;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.config-table {
  width: 100%;
  border-collapse: collapse;
}

.config-table th,
.config-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}

.config-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.remark-cell {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-cell {
  text-align: center;
  color: #999;
  padding: 30px 0;
}

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  color: #fff;
}

.action-btn.edit { background: #3498db; }

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 480px;
  max-width: 92%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-btn {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.required {
  color: #e74c3c;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-control:disabled {
  background: #f5f5f5;
  color: #999;
}

.form-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #888;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.btn-save {
  padding: 8px 16px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
